export default __webpack_public_path__ + "static/media/1953.8cb41b33.png";